import { formatPrice } from "@flicket/utils";
import { useMemo } from "react";
import { LineItem } from "~features/checkout/common/checkout.types";
import { DiscountType, OrderQuery, PromoCodeFragment } from "~graphql/sdk";
import { useOrganization } from "~hooks";
import { calculateDiscount } from "~lib/helpers/finance";

export type PromoCodeDiscountProps = {
  promoCode: OrderQuery["order"]["promoCode"];
  lineItems: LineItem[];
  activePromotions: any[];
};

const useCalculatePromoCodeDiscount = ({
  promoCode,
  lineItems,
  activePromotions,
}: PromoCodeDiscountProps) =>
  useMemo(() => {
    const discountAmount: number = calculateDiscount(
      promoCode,
      lineItems,
      activePromotions
    );

    return discountAmount;
  }, [promoCode, lineItems, activePromotions]);

export default useCalculatePromoCodeDiscount;

export function getPromoCodeLabel(
  promoCode: PromoCodeFragment["promoCode"],
  currency: string
) {
  const discountDisplay = (() => {
    if (promoCode.discountType === DiscountType.Fixed) {
      return formatPrice(promoCode.discountAmount, {
        currency,
      });
    }

    if (promoCode.discountType === DiscountType.Percentage) {
      return `${promoCode.discountAmount.toFixed(0)}%`;
    }

    // Should never happen
    return "";
  })();

  return <>{discountDisplay} discount applied</>;
}
